import * as actions from '../actions/print';

export const print = (state = false, action) => {
    if (action.type === actions.SET_PRINT){
        return action.data;
    }
    return state;
}
